// Central content for BBS Masonry LLC. Replace with real company data as needed.

export const COMPANY = {
  name: "BBS Masonry LLC",
  tagline: "West Michigan's Trusted Masonry & Chimney Experts for 30+ Years",
  phoneDisplay: "(616) 490-5213",
  phoneHref: "tel:+16164905213",
  email: "bbsmasonryllc@yahoo.com",
  hours: "Monday – Friday, 8:00 AM – 5:00 PM",
  foundedYear: "2011",
};

export const NAV_LINKS = [
  { label: "Services", target: "#services" },
  { label: "Gallery", target: "#gallery" },
  { label: "Why Us", target: "#why-us" },
  { label: "Reviews", target: "#testimonials" },
  { label: "Service Area", target: "#service-area" },
  { label: "FAQ", target: "#faq" },
];

export const TRUST_BADGES = [
  { icon: "Users", label: "Family Owned" },
  { icon: "ShieldCheck", label: "Licensed & Insured" },
  { icon: "BadgeCheck", label: "1-Year Labor Warranty" },
  { icon: "MapPin", label: "Serving Michigan" },
  { icon: "CalendarClock", label: "30+ Years Experience" },
  { icon: "ClipboardCheck", label: "Free Estimates" },
];

export const SERVICES = [
  {
    id: "chimney-repair",
    icon: "Wrench",
    title: "Chimney Repair",
    desc: "Cracked crowns, damaged flashing and deteriorating mortar joints repaired to keep water out and your chimney sound.",
    img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_bbs-masonry-preview/artifacts/od1wg8sb_IMG_8842.webp",
  },
  {
    id: "chimney-rebuilds",
    icon: "Hammer",
    title: "Chimney Rebuilds",
    desc: "Full or partial rebuilds using quality brick and stone when a chimney is beyond simple repair.",
    img: "https://images.unsplash.com/photo-1588712757679-06a3428ce119?crop=entropy&cs=srgb&fm=jpg&w=940&q=85",
  },
  {
    id: "brick-repair",
    icon: "Grid3x3",
    title: "Brick Repair",
    desc: "Matching brick, replacing spalled units and restoring the strength and look of your masonry walls.",
    img: "https://static.prod-images.emergentagent.com/jobs/7df1fd62-4a44-4070-85be-4f4df1ca28ca/images/84338c62a6ce82e6007fe71040e75f4e45e3223ef4dddc67c5fe18eb88e5360d.jpeg",
  },
  {
    id: "stone-masonry",
    icon: "Mountain",
    title: "Stone Masonry",
    desc: "Custom natural and manufactured stonework for facades, veneers, pillars and outdoor living features.",
    img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_bbs-masonry-preview/artifacts/k24ua5cg_IMG_8847.webp",
  },
  {
    id: "block-masonry",
    icon: "Boxes",
    title: "Block Masonry",
    desc: "Durable concrete block construction for foundations, retaining walls and structural applications.",
    img: "https://static.prod-images.emergentagent.com/jobs/7df1fd62-4a44-4070-85be-4f4df1ca28ca/images/98bcda4496301e8352dac36f78e9bbaf1a72ed93395dc7b441656a24ff2e9775.jpeg",
  },
  {
    id: "tuckpointing",
    icon: "Ruler",
    title: "Tuckpointing",
    desc: "Removing old, failing mortar and repointing joints to protect and refresh aging brickwork.",
    img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_bbs-masonry-preview/artifacts/9bgznh88_IMG_8843.webp",
  },
  {
    id: "chimney-caps",
    icon: "Umbrella",
    title: "Chimney Caps",
    desc: "Custom and standard caps that keep out rain, animals and debris while improving draft.",
    img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_bbs-masonry-preview/artifacts/pznirduu_IMG_8845.webp",
  },
  {
    id: "fireplace-repair",
    icon: "Flame",
    title: "Fireplace Repair",
    desc: "Firebox, hearth and mantel restoration to bring your fireplace back to safe, beautiful working order.",
    img: "https://images.unsplash.com/photo-1612031737124-28aeae3f2863?crop=entropy&cs=srgb&fm=jpg&w=940&q=85",
  },
  {
    id: "waterproofing",
    icon: "Droplets",
    title: "Waterproofing",
    desc: "Breathable sealants and proper drainage detailing to defend masonry against Michigan's freeze-thaw cycles.",
    img: "https://images.unsplash.com/photo-1783185572085-771e3cc1f368?crop=entropy&cs=srgb&fm=jpg&w=940&q=85",
  },
];

export const GALLERY = [
  {
    id: "g1",
    title: "Chimney Rebuild",
    location: "Grand Rapids, MI",
    before: "https://images.unsplash.com/photo-1676385386406-b0091ded663e?crop=entropy&cs=srgb&fm=jpg&w=940&q=85",
    after: "https://customer-assets-m6fa6gv7.emergentagent.net/job_bbs-masonry-preview/artifacts/od1wg8sb_IMG_8842.webp",
  },
  {
    id: "g2",
    title: "Tuckpointing & Brick Repair",
    location: "Holland, MI",
    before: "https://images.pexels.com/photos/31844481/pexels-photo-31844481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    after: "https://customer-assets-m6fa6gv7.emergentagent.net/job_bbs-masonry-preview/artifacts/9bgznh88_IMG_8843.webp",
  },
  {
    id: "g3",
    title: "Stone Veneer Facade",
    location: "Traverse City, MI",
    before: "https://images.unsplash.com/photo-1773101883541-42a4881daef3?crop=entropy&cs=srgb&fm=jpg&w=940&q=85",
    after: "https://customer-assets-m6fa6gv7.emergentagent.net/job_bbs-masonry-preview/artifacts/kds32ah0_IMG_8846.webp",
  },
];

export const WHY_US = [
  {
    n: "01",
    title: "Experienced Craftsmen",
    desc: "More than three decades of hands-on masonry and chimney work across West Michigan, with craftsmen who take pride in every joint and course they lay.",
  },
  {
    n: "02",
    title: "Honest Pricing",
    desc: "Clear, itemized free estimates with no pressure and no surprise fees. You know exactly what you're paying for before we begin.",
  },
  {
    n: "03",
    title: "Quality Materials",
    desc: "We use durable brick, stone, block and mortar built to withstand Michigan winters, so your investment lasts for decades.",
  },
  {
    n: "04",
    title: "Attention to Detail",
    desc: "From tooling mortar joints to matching existing brick, the small details are where we set our work apart.",
  },
  {
    n: "05",
    title: "Reliable Communication",
    desc: "We show up when we say we will and keep you updated from the first estimate to the final walkthrough.",
  },
  {
    n: "06",
    title: "Local Reputation",
    desc: "A family-owned company that lives and works here — our neighbors' trust is the foundation of our business.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Karen M.",
    location: "Grand Rapids, MI",
    rating: 5,
    quote:
      "BBS rebuilt our failing chimney and it looks better than the day the house was built. Honest estimate, spotless cleanup, and the crew was respectful the entire time.",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
  },
  {
    name: "David R.",
    location: "Holland, MI",
    rating: 5,
    quote:
      "Had brick repair and tuckpointing done on our 1920s home. The color match is perfect — you truly cannot tell where the old ends and new begins. Highly recommend.",
    img: "https://images.unsplash.com/photo-1543949806-2c9935e6aa78?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
  },
  {
    name: "Susan T.",
    location: "Muskegon, MI",
    rating: 5,
    quote:
      "From the free estimate to the finished stone fireplace, everything was professional and on schedule. It's now the centerpiece of our living room.",
    img: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
  },
  {
    name: "Mark H.",
    location: "Cadillac, MI",
    rating: 5,
    quote:
      "They drove up north to cap and waterproof our chimney and did fantastic work. Fair pricing and they stood behind everything with their labor warranty.",
    img: "https://images.pexels.com/photos/12446392/pexels-photo-12446392.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300",
  },
  {
    name: "Jennifer L.",
    location: "Ludington, MI",
    rating: 5,
    quote:
      "Reliable, tidy and genuinely kind people. The communication was excellent and the finished brickwork exceeded what we expected. A true family business.",
    img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&w=300&q=80",
  },
];

export const SERVICE_CITIES = [
  "Grand Rapids", "Grand Haven", "Muskegon", "Holland", "Wyoming",
  "Kentwood", "Cadillac", "Ludington", "Traverse City", "Big Rapids",
  "Newaygo", "Kalamazoo", "Lansing", "Detroit", "and beyond",
];

export const FAQS = [
  {
    q: "Do you offer free estimates?",
    a: "Yes. We provide free, no-obligation estimates for all masonry and chimney projects. Request one online or call us and we'll schedule a time to assess your project.",
  },
  {
    q: "How much does chimney repair cost?",
    a: "Cost varies widely based on the type and extent of damage — from minor repointing to full rebuilds. That's exactly why we provide a free, itemized estimate so you get an accurate price for your specific chimney.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes, BBS Masonry LLC is licensed and insured. We're happy to provide documentation before any work begins so you can hire us with confidence.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in West Michigan and serve communities across the state — including Grand Rapids, Holland, Muskegon, Cadillac, Ludington, Traverse City and even Detroit for the right project. If you're unsure, just ask.",
  },
  {
    q: "How long does a chimney rebuild take?",
    a: "Most chimney rebuilds take a few days depending on size, height and weather. We'll give you a clear timeline with your estimate and keep you updated throughout the project.",
  },
  {
    q: "Do you repair fireplaces?",
    a: "Absolutely. We repair and restore fireboxes, hearths, mantels and surrounds — both masonry repairs and cosmetic restoration to get your fireplace safe and looking great.",
  },
];
